class FilterCollapse {
    constructor(options = {}) {
        this.containerSelector = options.containerSelector || '.product-filter-group';
        this.headerSelector = options.headerSelector || '.filter-group-header';
        this.contentSelector = options.contentSelector || '.filter-group-content';
        this.iconSelector = options.iconSelector || '.filter-group-icon';
        this.animationDuration = options.animationDuration || 200;

        // Add animation lock to prevent multiple toggles
        this.isAnimating = false;

        this.init();
    }

    init() {
        // Remove any existing event listeners
        $(this.headerSelector).off('click keypress');

        // Initialize all filter groups as expanded
        $(this.contentSelector).show();

        this.bindEvents();
    }

    bindEvents() {
        const self = this;

        // Handle click on filter headers
        $(this.headerSelector).on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (self.isAnimating) return;

            const container = $(this).closest(self.containerSelector);
            const content = $(this).next(self.contentSelector);
            const icon = $(this).find(self.iconSelector);

            self.toggleFilter(container, content, icon);
        });

        // Add keyboard accessibility
        $(this.headerSelector).on('keypress', function (e) {
            if (e.which === 13 || e.which === 32) { // Enter or Space
                e.preventDefault();
                e.stopPropagation();
                $(this).trigger('click');
            }
        }).attr('tabindex', '0');
    }

    toggleFilter(container, content, icon) {
        if (this.isAnimating) return;

        this.isAnimating = true;

        content.stop(true, true).slideToggle(this.animationDuration, () => {
            const isVisible = content.is(':visible');

            // Update icon rotation
            if (isVisible) {
                icon.removeClass('rotate-180');
            } else {
                icon.addClass('rotate-180');
            }

            // Dispatch custom event
            window.dispatchEvent(new CustomEvent('filterCollapseChanged', {
                detail: {
                    container: container,
                    isVisible: isVisible,
                    filterType: container.data('filter-type')
                }
            }));

            this.isAnimating = false;
        });
    }

    // Public methods for external control
    expandAll() {
        const self = this;
        $(this.containerSelector).each(function () {
            const content = $(this).find(self.contentSelector);
            const icon = $(this).find(self.iconSelector);
            content.slideDown(self.animationDuration);
            icon.removeClass('rotate-180');
        });
    }

    collapseAll() {
        const self = this;
        $(this.containerSelector).each(function () {
            const content = $(this).find(self.contentSelector);
            const icon = $(this).find(self.iconSelector);
            content.slideUp(self.animationDuration);
            icon.addClass('rotate-180');
        });
    }
}

export default FilterCollapse;
